const DB_NAME = "wcei-offline";
const STORE = "pending_writes";

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      req.result.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function notifyChange() {
  window.dispatchEvent(new CustomEvent("wcei-offline-queue-changed"));
}

export async function queueWrite(entry) {
  const db = await openDB();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).add({ ...entry, timestamp: Date.now() });
    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
  });
  notifyChange();
}

export async function getQueue() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const req = tx.objectStore(STORE).getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function removeFromQueue(id) {
  const db = await openDB();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
  });
  notifyChange();
}

export function isNetworkError(error) {
  return !error?.response && !!error?.request;
}

export async function flushQueue(api) {
  const items = (await getQueue()).sort((a, b) => a.timestamp - b.timestamp);
  let synced = 0;
  for (const item of items) {
    try {
      await api.request({ method: item.method, url: item.url, data: item.data });
      await removeFromQueue(item.id);
      synced++;
    } catch (e) {
      if (isNetworkError(e)) break;
      await removeFromQueue(item.id);
    }
  }
  return synced;
}
